import { Button, Card, Checkbox, Col, Form, Input, message, Radio, Row, Select, Spin } from "antd"
import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { BASE_API } from "../../axios";
import { getUserDetails, makeGetCall, makePostCall, setAccessToken, setUserDetails } from "../../utils/helper";
// import "./add-template.scss";
import { useForm } from "antd/es/form/Form";
import CustomEditor from "../custom-editor";
import ErrorBoundary from "../../components/ErrorBoundary";

const { Option } = Select;

const AddTemplate = () => {

  const [templateForm] = useForm();
  const [modalitites, setModalities] = useState([]);
  const [bodyPartsList, setBodyPartsList] = useState([]);
  const [selectedModality, setSelectedModality] = useState(null);
  const [templateHtml, setTemplateHtml] = useState(null);
  const [submitInProgress, setSubmitInProgress] = useState(false);
  const [loadingState, setLoadingState] = useState({ modalities: false, bodyParts: false, error: null });

  const getModalities = useCallback(() => {
    setLoadingState(prev => ({ ...prev, modalities: true, error: null }));
    makeGetCall('/modalities')
      .then(res => {
        setModalities(res.data?.data || []);
        setLoadingState(prev => ({ ...prev, modalities: false }));
      })
      .catch(e => {
        const errorMessage = e.response?.data?.message || e.message || 'Failed to load modalities';
        setLoadingState(prev => ({ ...prev, modalities: false, error: errorMessage }));
        message.error(`Error loading modalities: ${errorMessage}`);
      })
  }, []);

  const getBodyParts = useCallback(() => {
    setLoadingState(prev => ({ ...prev, bodyParts: true, error: null }));
    makeGetCall('/body-parts')
      .then(res => {
        setBodyPartsList(res.data?.data || []);
        setLoadingState(prev => ({ ...prev, bodyParts: false }));
      })
      .catch(e => {
        const errorMessage = e.response?.data?.message || e.message || 'Failed to load body parts';
        setLoadingState(prev => ({ ...prev, bodyParts: false, error: errorMessage }));
        message.error(`Error loading body parts: ${errorMessage}`);
      })
  }, []);

  useEffect(() => {
    getModalities();
    getBodyParts();
  }, [getModalities, getBodyParts]);

  const handleModalityChange = useCallback((value) => {
    setSelectedModality(value);
    // Clear body part selection when modality changes
    templateForm.setFieldsValue({ body_part: undefined });
  }, [templateForm]);

  const filteredBodyParts = bodyPartsList.filter(bodyPart =>
    !selectedModality || bodyPart.modality === selectedModality
  );

  const onSubmit = useCallback(() => {
    const { modality, body_part, name } = templateForm.getFieldsValue();

    if (!templateHtml || templateHtml.trim() === '') {
      message.error("Please provide template content");
      return;
    }

    const payload = {
      modality, body_part, name, user_id: getUserDetails().username, html: templateHtml
    };
    setSubmitInProgress(true);
    makePostCall('/add-template', payload)
      .then(res => {
        if (res.data?.success) {
          message.success('Template added successfully');
          templateForm.resetFields();
          setTemplateHtml(null);
        } else {
          const errorMessage = res.data?.message || 'Failed to add template';
          message.error(errorMessage);
        }
      })
      .catch(e => {
        const errorMessage = e.response?.data?.message || e.message || 'Failed to add template';
        message.error(errorMessage);
      })
      .finally(() => {
        setSubmitInProgress(false);
      });
  }, [templateForm, templateHtml]);

  return (
    <ErrorBoundary>
      <Spin spinning={submitInProgress || loadingState.modalities || loadingState.bodyParts} tip={submitInProgress ? "Saving template..." : "Loading data..."}>
        <div className="admin-form-container">
        {loadingState.error && (
          <div className="error-container">
            <strong>Error:</strong> {loadingState.error}
            <Button
              type="link"
              size="small"
              onClick={() => {
                getModalities();
                getBodyParts();
              }}
              className="retry-button"
            >
              Retry
            </Button>
          </div>
        )}
        <div className="add-template-main-container">
          {/* Page Title */}
          <div className="admin-form-header">
            <h1 className="admin-form-title">Create New Template</h1>
          </div>
            <Form form={templateForm} onFinish={onSubmit} className="modern-form">
              <div className="form-grid three-columns">
                <Form.Item
                  label="Modality"
                  name="modality"
                  rules={[
                    {
                      required: true,
                      message: "Please select modality!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select modality"
                    onChange={handleModalityChange}
                  >
                    {modalitites?.map(modality => (
                      <Option key={modality.code || modality.value} value={modality.code || modality.value}>
                        {modality.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Body Part"
                  name="body_part"
                  rules={[
                    {
                      required: true,
                      message: "Please select body part!",
                    },
                  ]}
                >
                  <Select
                    placeholder={selectedModality ? "Select body part" : "Select modality first"}
                    disabled={!selectedModality}
                  >
                    {filteredBodyParts?.map(bodyPart => (
                      <Option key={bodyPart.code || bodyPart.value} value={bodyPart.code || bodyPart.value}>
                        {bodyPart.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Template Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input template name!",
                    },
                  ]}
                >
                  <Input placeholder="Enter template name" />
                </Form.Item>
              </div>

              <div className="custom-editor-wrapper">
                <CustomEditor
                  initialContent={''}
                  handleChange={useCallback((html) => {
                    setTemplateHtml(html);
                  }, [])}
                />
              </div>

              <Form.Item className="text-center mt-2">
                <Button type="primary" htmlType="submit" className="admin-create-btn" size="large">
                  Create Template
                </Button>
              </Form.Item>
            </Form>
        </div>
        </div>
      </Spin>
    </ErrorBoundary>
  )
}


export default AddTemplate;
